import {
  QuestionnaireFormView,
} from ".";

export const questionnaireRoutes = [
  {
    path: "/questionnaire/:questionnaireId?",
    name: "questionnaire",
    component: QuestionnaireFormView,
  },
];